// removed by extract-text-webpack-plugin
module.exports = {"sm":"only screen and (min-width: 48em)","md":"only screen and (min-width: 64em)","lg":"only screen and (min-width: 75em)","container":"container-2q_5X","comment":"comment-332Dz","commentImgCol":"commentImgCol-3vZ6N","commentImg":"commentImg-3JgS2","textCol":"textCol-2VzS6","text":"text-3YVrR","postBox":"postBox-370io","commentInput":"commentInput-1g7dI input-2t6DG","postContainer":"postContainer-a4EIB","commentMeta":"commentMeta-34yX5","date":"date-1LomL","delete":"delete-1xZVQ","deleteLoading":"deleteLoading-1I_OR","readMore":"readMore-2BOte","readMoreLoading":"readMoreLoading-1JrbX","error":"error-R9eU0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/home/feed/_comments.css
// module id = 1209
// module chunks = 1